import React, { useEffect, useState } from 'react';
import './FloatingPetals.css';

const FloatingPetals = () => {
  const [petals, setPetals] = useState([]);

  useEffect(() => {
    const createPetal = () => {
      const id = Date.now() + Math.random();
      const petal = {
        id,
        left: Math.random() * 100,
        size: 8 + Math.random() * 14,
        duration: 8 + Math.random() * 12,
        delay: Math.random() * 2,
        rotation: Math.random() * 360,
        sway: 30 + Math.random() * 80,
        type: Math.floor(Math.random() * 3),
      };

      setPetals(prev => [...prev.slice(-5), petal]);
    };

    const interval = setInterval(createPetal, 5000);
    for (let i = 0; i < 2; i++) {
      setTimeout(createPetal, i * 900);
    }

    return () => clearInterval(interval);
  }, []);

  const petalColors = [
    'radial-gradient(ellipse, #E74C3C 0%, #C0392B 70%)',
    'radial-gradient(ellipse, #F5C518 0%, #D4A812 70%)',
    'radial-gradient(ellipse, #FFB6C1 0%, #FF69B4 70%)',
  ];

  return (
    <div className="floating-petals" aria-hidden="true">
      {petals.map(petal => (
        <div
          key={petal.id}
          className="petal"
          style={{
            left: `${petal.left}%`,
            width: `${petal.size}px`,
            height: `${petal.size * 1.3}px`,
            background: petalColors[petal.type],
            animationDuration: `${petal.duration}s`,
            animationDelay: `${petal.delay}s`,
            '--rotation': `${petal.rotation}deg`,
            '--sway': `${petal.sway}px`,
          }}
        />
      ))}
    </div>
  );
};

export default FloatingPetals;
